const players = new Map();
let initialized = false;

function initGlobalPlayListener() {
  if (initialized || typeof document === 'undefined') return;
  initialized = true;

  document.addEventListener(
    'play',
    (event) => {
      const current = event.target;
      if (!(current instanceof HTMLVideoElement)) return;

      players.forEach(({ onForcePause, getVideoEl }) => {
        const el = getVideoEl?.();
        if (el !== current) onForcePause();
      });

      document.querySelectorAll('video').forEach((video) => {
        if (video !== current && !video.paused) {
          video.pause();
        }
      });
    },
    true
  );
}

export function registerExclusiveVideoPlayer(id, { onForcePause, getVideoEl }) {
  initGlobalPlayListener();
  players.set(id, { onForcePause, getVideoEl });
  return () => players.delete(id);
}

export function claimExclusiveVideoPlayback(playerId, videoEl = null) {
  players.forEach(({ onForcePause, getVideoEl }, id) => {
    if (id === playerId) return;
    const el = getVideoEl?.();
    if (el !== videoEl) onForcePause();
  });

  if (typeof document !== 'undefined') {
    document.querySelectorAll('video').forEach((video) => {
      if (video !== videoEl && !video.paused) {
        video.pause();
      }
    });
  }
}
